import './Games.css';
import '../animations.css';
import XWlogo from '../media/XW-logo.png';
import Blogo from '../media/botanic-logo.png';
import { useEffect, useState, useRef } from 'react';

function Games() {
  const [imageLoaded, setImageLoaded] = useState(false);
  const xenoContainerRef = useRef(null);
  const botanicContainerRef = useRef(null);

  useEffect(() => {
    const WXbg = new Image();
    WXbg.src = 'https://cd-1302933783.cos.ap-guangzhou.myqcloud.com/XenoHomepage/WX-bg-WEBP.webp';
    WXbg.onload = () => setImageLoaded(true);
    // 加载首页时同时加载一下business页面的图片
    const buz = new Image();
    buz.src = 'https://cd-1302933783.cos.ap-guangzhou.myqcloud.com/XenoHomepage/yoga-bg.png';
  }, []);

  // 滚动监听，检测元素是否进入视口
  useEffect(() => {
    const handleScroll = () => {
      const checkVisibility = (ref) => {
        if (!ref.current) return false;
        const rect = ref.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        // 当元素的顶部进入视口底部80%位置时触发（提前一点触发）
        // 或者元素底部还在视口内
        return rect.top < viewportHeight * 0.8 && rect.bottom > 0;
      };

      // 检查每个容器
      [xenoContainerRef, botanicContainerRef].forEach(ref => {
        if (ref.current && checkVisibility(ref)) {
          ref.current.classList.add('visible');
        }
      });
    };

    // 初始检查
    handleScroll();
    
    // 添加滚动监听
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="Games">
      <div className={`Games-Xeno background ${imageLoaded ? 'loaded' : ''}`}>  
        <div ref={xenoContainerRef} className='animate-on-scroll'>
          <img 
            src={XWlogo} 
            alt='xenowanderer'
            className='Games-Xeno-logo'
          />
          <a href='https://cd-1302933783.cos.ap-guangzhou.myqcloud.com/XenoHomepage/XW-LOGO-WEBP.webp' target='_blank' rel='noreferrer'>
            <button className='Games-Xeno-button button'>
              Info
            </button>
          </a>
        </div>
      </ div>
      <div className='Games-Botanic background'>  
        <div ref={botanicContainerRef} className='animate-on-scroll-below'>
          <img 
            src="https://cd-1302933783.cos.ap-guangzhou.myqcloud.com/XenoHomepage/botanic-logo.webp" 
            alt='botanic' 
            className='Games-Botanic-logo'
          />
          <a href='https://x.com/XenowalkerMR' target='_blank' rel='noreferrer'>
            <button className='Games-Botanic-button button'>
              Info
            </button>
          </a>
        </div>
      </ div>
    </div>
  );
}

export default Games;

